import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    const isPageAnchor = /^#[A-Za-z][\w:.-]*$/.test(hash);

    if (isPageAnchor) {
      // Wait for the page to render, then scroll to the anchor
      const timeout = setTimeout(() => {
        const element = document.getElementById(decodeURIComponent(hash.slice(1)));
        if (element) {
          element.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      }, 100);
      return () => clearTimeout(timeout);
    } else {
      window.scrollTo(0, 0);
    }
  }, [pathname, hash]);

  return null;
};

export default ScrollToTop;
